import { globalTheme } from "../../styles";
import FlagIcon from "@mui/icons-material/Flag";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ErrorIcon from "@mui/icons-material/Error";
import HelpIcon from "@mui/icons-material/Help";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import { blue, green, red, yellow } from "@mui/material/colors";

interface Flag {
  id?: number;
  value?: string;
  text?: string;
  icon?: JSX.Element;
}

export const getIconByValue = (value: string): JSX.Element | null => {
  const flag = Flags().find((f) => f.value === value);
  return flag?.icon || null;
};

export const Flags = (): Flag[] => {
  return [
    { id: 0, value: "NO_FLAG", text: "No Flag" },
    { id: -2, value: "ITEM_COPIED", icon: <ContentCopyIcon />, text: "Item Copied" },
    { id: -1, value: "EXCLAMATION_POINT", icon: <ErrorIcon sx={{ color: red[500] }} />, text: "Issue With Customer" },
    { id: 1, value: "RED_FLAG", icon: <FlagIcon sx={{ color: red[500] }} />, text: "Red Flag" },
    { id: 2, value: "QUESTION_MARK", icon: <HelpIcon sx={{ color: blue[500] }} />, text: "Local Pickup" },
    { id: 3, value: "NOT_AVAILABLE", icon: <DoNotDisturbAltIcon sx={{ color: red[400] }} />, text: "Not Available" },
    { id: 4, value: "PRICE", icon: <LocalAtmIcon sx={{ color: green[400] }} />, text: "Price" },
    { id: 5, value: "YELLOW_FLAG", icon: <FlagIcon sx={{ color: yellow[500] }} />, text: "Yellow Flag" },
    { id: 6, value: "GREEN_FLAG", icon: <FlagIcon sx={{ color: green[500] }} />, text: "To be Processed" },
    { id: 7, value: "BLUE_FLAG", icon: <FlagIcon sx={{ color: blue[500] }} />, text: "Issue to be noticed" },
  ];
};
